import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ba08046"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 text-2xl font-bold" }, "Invoices", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Debit: ", -1))
const _hoisted_3 = { class: "font-bold text-primary" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Refund: ", -1))
const _hoisted_5 = { class: "font-bold text-primary" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Total: ", -1))
const _hoisted_7 = { class: "font-bold text-primary" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "danger" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "success" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "base-cost" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, { class: "hide-croll" }), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 24,
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("p", null, [
                _hoisted_2,
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatterDollars(_ctx.totalSeller)), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatterDollars(_ctx.creditSeller)), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatterDollars(_ctx.totalSeller - _ctx.creditSeller)), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { class: "flex item-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_filter_table, {
            onOnFilterCallback: _ctx.onFilterCallback,
            placeholder: "Invoice"
          }, null, 8, ["onOnFilterCallback"]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.params.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.type) = $event)),
            placeholder: "Debit/Credit",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
            { label: 'Debit', value: 'OUT' },
            { label: 'Credit', value: 'IN' },
          ], (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  placeholder: "Debit/Credit",
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.data.daterange,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.daterange) = $event)),
            onChange: _ctx.onChangeDate,
            type: "daterange",
            "range-separator": "To",
            "start-placeholder": "Start date",
            "end-placeholder": "End date"
          }, null, 8, ["modelValue", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        span: 24,
        class: "my-3"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_el_table, { data: _ctx.documents }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                property: "createdDate",
                label: "Created",
                "min-width": 10
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.moment(scope.row.createdDate).format('YYYY-MM-DD HH:mm')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                property: "name",
                label: "Invoice",
                "min-width": 15
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_router_link, {
                    to: { path: `/s/invoices/${scope.row._id}` }
                  }, {
                    default: _withCtx(({ href }) => [
                      _createVNode(_component_el_link, {
                        href: href,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row._id), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                property: "sellerAmount",
                label: "Debit",
                "min-width": 8
              }, {
                default: _withCtx((scope) => [
                  (scope.row.type == 'OUT')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatterDollars(scope.row.sellerAmount)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                property: "sellerAmount",
                label: "Credit",
                "min-width": 8
              }, {
                default: _withCtx((scope) => [
                  (scope.row.type == 'IN')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.formatterDollars(scope.row.sellerAmount)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                property: "sellerAmount",
                label: "Balance",
                "min-width": 8
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatterDollars(scope.row.remainAmount) || 0), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                property: "note",
                label: "Note",
                "min-width": 12
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.note), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                property: "status",
                label: "Export",
                "min-width": 8
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("a", {
                    class: "text-primary",
                    href: "#",
                    onClick: ($event: any) => (_ctx.onExportInvoice(scope.row))
                  }, " Download ", 8, _hoisted_15)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]), [
            [_directive_loading, _ctx.isLoading]
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_pagination, {
              total: _ctx.total,
              pagination: _ctx.params.page,
              "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.page) = $event)),
              limit: _ctx.params.limit,
              "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.limit) = $event))
            }, null, 8, ["total", "pagination", "limit"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}